import * as types from '../types.js';

export default {

	html: `
		<style>
			#location #company_id		{ width: 10rem;		}
			#location #warehouse_id	{ width: 10rem;		}
			#location #id				{ width: 4rem; text-align: right;	}
			#location #address			{ width: 6rem;		}
			#location #mix				{ width: 12rem; display: inline-block;	}
			#location #level			{ width: 3rem; text-align: right;	}
			#location #status	 		{ width: 10rem;		}
		</style>
		<form id="location" class="form" autocomplete="off">
			<datalist id="companies">
			</datalist>
			<datalist id="warehouses">
			</datalist>
			<div class="fsb">
				<label title="Empresa">Empresa<sup>*</sup>
					<input id="company_id" type="text" list="companies" required>
				</label>
				<label title="Armazém">Armazém<sup>*</sup>
					<input id="warehouse_id" type="text" list="warehouses" required>
				</label>
				<label title="Identificador da posição">Posição
					<input id="id" type="text" disabled>
				</label>
				<label title="Endereço da posição">Endereço<sup>*</sup>
					<input id="address" type="text" required>
				</label>
				<label title="Nível da posição (1=mais baixo)">Nível<sup>*</sup>
					<input id="level" type="text" value="1" required>
				</label>
				<label title="Posição ao alcance da mão?">Atuante?
					<input id="in_reach" type="checkbox" checked>
				</label>
				<label title="Posição de descarga de mercadorias?">Staging?
					<input id="is_staging" type="checkbox">
				</label>
				<label title="Status da posição">Status<sup>*</sup>
					<input id="status" type="text" list="location_status" value="0" required>
				</label>
			</div>
			<div class="fsb">
				<label class="keymap">Classes<sup>*</sup>
					<select id="classes" multiple size="4" required>
					</select>
				</label>
				<span class="keymap">
					<button type="button" class="bn_Left" title="Incluir classificações selecionadas à direita"> &#x1F844;</button>
					<button type="button" class="bn_Right" title="Remover classificações selecionadas à esquerda">&#x1F846;</button>
				</span>
				<label class="keymap">Disponíveis
					<select id="available" multiple size="4">
					</select>
				</label>
			</div>
			<div class="fsb fae mtm">
				<span>
					<label title="Misturas permitidas na posição">Mix<sup>*</sup>
						<input id="mix" type="text" list="location_mixes" value="0" required>
					</label>
				</span>
				<span>
					<button type="button" class='bn_Escape button'>Fechar</button>
					<button type="button" class='bn_Enter button'>Salvar</button>
				</span>
			</div>
		</form>
	`,

	form: 
	{
		selector: '#location',
		init(formset)
		{
			formset.loadList('#companies', 'companies', { labels: ['nick'] });
			Object.getPrototypeOf(this).init.call(this);
		},
	},
	
	fields: [
		{ properties: { selector: '#company_id' }, types: [types.pubsub(), types.datalist()] },
		{ properties: { selector: '#warehouse_id' }, types: [types.pubsub(), types.datalist(), types.observer('company_id'), types.obs_load_options('warehouses')] },
		{ properties: { selector: '#id' }, types: [types.number(0, 2)] },
		{ properties: { selector: '#address' }, types: [types.location_address(), types.caps()] },
		{ properties: { selector: '#mix' }, types: [types.opt_location_mix(), types.datalist()] },
		{ properties: { selector: '#level' }, types: [types.number(0, 2)] },
		{ properties: { selector: '#in_reach' }, types: [types.checkbox()] },
		{ properties: { selector: '#is_staging' }, types: [types.checkbox()] },
		{ properties: { selector: '#status' }, types: [types.opt_location_status(), types.datalist()] },
		{ properties: { selector: '#classes' }, types: [types.pubsub(), types.keymap('classes', '#available', { values: ['company_id', 'id'] }), types.observer('company_id'), types.obs_load_keymap()] },
	]

};
